/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { FlagResponse } from "../types/FlagResponse";
export const Response = FlagResponse.optional();
